import orderBy from "lodash/orderBy";
import getCards from "./get-cards";

/*
 * Sort and filter cycles or programs
 * @param {Array} cycles - The cycle objects to be sorted and filtered
 * @param {Array} sortMethod - One of 'name', 'nameDescending', 'createdDate', 'modifiedDate', 'progress'
 * @param {Array} programType - One of "user", "coach", "premium", "standard"
 * @param {Array} progressFilter - One of "Upcoming", "In Progress", "Completed", "In Progress"
 * @param {Array} programView - One of "programs", "cycles"
 * @param {Array} programOwner - One of "all", "coach", "user"
 * @returns {array} Either cycles or programs
 */
const sortByArgument = {
  name: [[(card) => String(card.name).toLowerCase()]],
  nameDescending: [[(card) => String(card.name).toLowerCase()], ["desc"]],
  createdDate: [["createdDate"], ["desc"]],
  modifiedDate: [["modifiedDate"], ["desc"]],
  progress: [["progress"]],
};

const sortPriorities = {
  "In Progress": 1,
  Upcoming: 2,
  Completed: 3,
  Unscheduled: 4,
};

const progressCompare = (cardA, cardB) => {
  return sortPriorities[cardA.progress] - sortPriorities[cardB.progress];
};

const sortPrograms = (
  cycles,
  sortMethod,
  programType,
  progressFilter,
  programView,
  programOwner,
  filters
) => {
  const cards = getCards({
    cycles,
    programType,
    cardType: programView,
    progressFilter,
    programOwner,
    filters,
  });

  // Used in the program builder landing page.
  if (!sortMethod || ["Sort", "sort", "all"].includes(sortMethod))
    sortMethod = "modifiedDate";

  if (sortMethod === "progress") {
    return cards.sort(progressCompare);
  }

  const sorted = orderBy(cards, ...sortByArgument[sortMethod]);
  return sorted;
};

export default sortPrograms;
